export default "__VITE_ASSET__DHzSxWBY__"